import { upperFirst } from 'lodash'
import Head from 'next/head'
import * as React from 'react'

import {
  COMPANY_NAME_IN_USE,
  HELP_EMAIL
} from '~/lib/util/fe/style-guide/branding-assets'

const Layout: React.FC<any> = (props) => {
  return (
    <div>
      <Head>
        <title>{props.title}</title>
      </Head>

      <div>{props.children}</div>

      <footer
        className="fixed p-2.5 bottom-0 w-full flex items-center justify-center h-10 border-t border-primary-300 margin-0 bg-bg-black group"
        data-testid="footer"
      >
        <p
          className="inline-block text-white text-xs m-0 pr-1 mr-1 md:text-sm md:mr-2.5 md:pr-2.5 transition-all border-primary-600 group-hover:opacity-100"
          data-testid="footerCopyrightText"
        >
          © {new Date().getFullYear()} {upperFirst(COMPANY_NAME_IN_USE)}{' '}
          Messaging
        </p>
        <p className="inline-block  text-white text-xs m-0 pr-1 mr-1 md:text-sm md:mr-2.5 md:pr-2.5 transition-all border-primary-600 group-hover:opacity-100">
          <a
            href="https://www.strivemessaging.org/terms/"
            target="__blank"
            data-testid="footerTosLink"
            className="text-xs md:text-sm text-white underline cursor-pointer"
          >
            Terms
          </a>
        </p>
        <p className="inline-block text-white text-xs m-0 pr-1 mr-1 md:text-sm md:mr-2.5 md:pr-2.5 transition-all border-primary-600 group-hover:opacity-100">
          <a
            href="https://www.strivemessaging.org/privacy/"
            target="__blank"
            data-testid="footerPrivacyPolicyLink"
            className="text-xs md:text-sm text-white underline cursor-pointer"
          >
            Privacy
          </a>
        </p>
        <p className="inline-block text-white text-xs m-0 pr-1 mr-1 md:text-sm md:mr-2.5 md:pr-2.5 transition-all border-primary-600 group-hover:opacity-100">
          Powered by{' '}
          <a
            href="https://www.strivemessaging.org/"
            target="__blank"
            data-testid="footerPoweredByLink"
            className="text-xs md:text-sm text-white underline cursor-pointer"
          >
            {upperFirst(COMPANY_NAME_IN_USE)} Messaging
          </a>
        </p>
        <p className="inline-block text-white text-xs m-0 pr-1 mr-1 md:text-sm md:mr-2.5 md:pr-2.5 transition-all group-hover:opacity-100">
          Need help?{' '}
          <a
            href={`mailto:${HELP_EMAIL}`}
            data-testid="footerContactUsLink"
            className="text-xs md:text-sm text-white underline cursor-pointer"
          >
            Contact us
          </a>
        </p>
      </footer>
    </div>
  )
}
export default Layout
